<template>
  <v-dialog
    v-model="dialog_ativo"
    fullscreen
    transition="dialog-bottom-transition"
    persistent
  >
    <template #activator="{ on, attrs }">
      <button id="btn-carrinho" :class="{'cursor-no-drop': !pedido.id}" @click="abrirCarrinhoCompra">
        <v-icon v-text="'mdi-cart'" color="#142454" />
        <span v-text="'Carrinho'" />

        <span class="quantidade font-11">
          <v-progress-circular
            v-if="carregando_dados"
            color="red"
            indeterminate
            size="16"
            width="1.5"
          />
          <span v-else v-text="pedido.qtd_categorias || 0" />
        </span>
      </button>
    </template>

    <v-card>
      <Titulo
        v-model="dialog_ativo"
        :pedido="pedido"
        @pedido-compra-finalizado="pedidoCompraFinalizado"
      />

      <TabelaProdutos v-if="dialog_ativo" :pedido="pedido" />
    </v-card>
  </v-dialog>
</template>

<script>
import Titulo from "./Titulo.vue";
import TabelaProdutos from "./TabelaProdutos.vue";
import {buscarPedidoAbertoDepartamento} from "@/api/compras/MateriaPrima";
import {mapGetters} from "vuex";

const PEDIDO_DEFAULT = {
  id: null,
  qtd_produtos: 0,
  created_at: null,
}

export default {
  name: "CarrinhoMateriaPrima",
  components: {
    Titulo,
    TabelaProdutos
  },
  data: () => ({
    dialog_ativo: false,
    carregando_dados: false,
    pedido:  {}
  }),
  computed: {
    ...mapGetters({
      'grupo_compra': 'usuario/getGrupoCompras',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
      'callbackAtualizarTabelaCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias'
    }),
  },
  watch: {
    grupo_compra() {
      this.buscarPedidoAbertosCategorias();
    },
    dialog_ativo(valor) {
      if (!valor) {
        this.callbackAtualizarCardsTotais();
        this.callbackAtualizarTabelaCategorias();
        this.buscarPedidoAbertosCategorias();
      }
    }
  },
  created() {
    this.buscarPedidoAbertosCategorias();
    this.setCallbackAtualizarCarrinho();
  },
  methods: {
    async buscarPedidoAbertosCategorias() {
      this.carregando_dados = true;

      const pedido = await buscarPedidoAbertoDepartamento(this.grupo_compra);

      if (pedido && pedido.id > 0) {
        this.pedido = pedido;
      } else {
        this.setPedidoDefault();
      }

      this.carregando_dados = false;
    },
    setPedidoDefault() {
      this.pedido = Object.assign({}, PEDIDO_DEFAULT);
    },
    setCallbackAtualizarCarrinho() {
      // função serve para atualizar o carrinho de qualquer lugar.
      this.$store.dispatch("compraMateriaPrima/callbackAtualizarCarrinhoCompra", this.buscarPedidoAbertosCategorias)
    },
    abrirCarrinhoCompra() {
      if (!this.pedido.id) return;

      this.dialog_ativo = true;
    },
    pedidoCompraFinalizado() {
      this.dialog_ativo = false;
    }
  }
}
</script>

<style scoped>
#btn-carrinho {
  padding: 2px 8px;
  background: #F7F8FD;
  border-radius: 8px;
  color: #142454;
  height: 30px;
  margin-top: 10px;
}
#btn-carrinho .quantidade {
  position: absolute;
  top: 3px;
  right: 10px;
  background: white;
  border-radius: 50%;
  border: 1px solid #948989;
  height: 20px;
  min-width: 20px;
}
</style>
